import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-39fb7eb4")

_pushScopeId("data-v-39fb7eb4")
const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row sticky" }
const _hoisted_4 = { class: "col-12" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-12 col-lg-12 col-xl-12" }
const _hoisted_7 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-12" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_balances = _resolveComponent("balances")
  const _component_OnBehalfOfOptions = _resolveComponent("OnBehalfOfOptions")
  const _component_router_view = _resolveComponent("router-view")
  const _component_CryptoBalances = _resolveComponent("CryptoBalances")
  const _component_TabPanel = _resolveComponent("TabPanel")
  const _component_OrderHistory = _resolveComponent("OrderHistory")
  const _component_TabView = _resolveComponent("TabView")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode(_component_balances, {
            onUpdate: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeCurrency($event)))
          })
        ])
      ]),
      _createVNode("div", _hoisted_5, [
        _createVNode("div", _hoisted_6, [
          _hoisted_7,
          _createVNode(_component_OnBehalfOfOptions),
          _hoisted_8,
          _createVNode(_component_router_view)
        ])
      ]),
      _hoisted_9,
      _createVNode("div", _hoisted_10, [
        _createVNode("div", _hoisted_11, [
          _createVNode(_component_TabView, { activeIndex: _ctx.indexTab }, {
            default: _withId(() => [
              _createVNode(_component_TabPanel, { header: "Portfolio balance" }, {
                default: _withId(() => [
                  _createVNode(_component_CryptoBalances, { initialLocalCurrency: _ctx.currencyBalance }, null, 8, ["initialLocalCurrency"])
                ]),
                _: 1
              }),
              _createVNode(_component_TabPanel, { header: "Order History" }, {
                default: _withId(() => [
                  _createVNode(_component_OrderHistory)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["activeIndex"])
        ])
      ])
    ])
  ]))
})